import { Cookie } from "lucide-react";

const clear = () => {
  try { localStorage.removeItem("proxireduc28_cookie_consent_v1"); } catch (e) { console.debug("cookie reset failed", e); }
  window.location.reload();
};

export default function Cookies() {
  return (
    <div className="max-w-3xl mx-auto px-4 py-14" data-testid="page-cookies">
      <div className="flex items-center gap-3 mb-6">
        <div className="w-12 h-12 rounded-xl bg-amber-50 text-amber-700 grid place-items-center"><Cookie size={22}/></div>
        <h1 className="font-heading text-3xl md:text-4xl font-extrabold">Cookies</h1>
      </div>
      <div className="bg-white border border-slate-200 rounded-2xl p-6 md:p-8 space-y-4 text-sm text-slate-700 leading-relaxed">
        <p>
          PROXIreduc-28 fonctionne avec un minimum de cookies. Aucun cookie publicitaire ni
          traceur tiers n'est déposé sur votre navigateur.
        </p>
        <div>
          <h2 className="font-heading text-lg font-bold text-slate-900">Cookies techniques (nécessaires)</h2>
          <table className="w-full text-xs mt-2 border border-slate-200 rounded overflow-hidden">
            <thead className="bg-slate-50 text-slate-600">
              <tr><th className="p-2 text-left">Nom</th><th className="p-2 text-left">Finalité</th><th className="p-2 text-left">Durée</th></tr>
            </thead>
            <tbody>
              <tr className="border-t border-slate-100">
                <td className="p-2 font-mono">access_token</td>
                <td className="p-2">Authentification (JWT httpOnly)</td>
                <td className="p-2">24 h</td>
              </tr>
              <tr className="border-t border-slate-100">
                <td className="p-2 font-mono">refresh_token</td>
                <td className="p-2">Renouvellement de session</td>
                <td className="p-2">7 jours</td>
              </tr>
              <tr className="border-t border-slate-100">
                <td className="p-2 font-mono">proxireduc28_cookie_consent_v1</td>
                <td className="p-2">Mémoriser votre choix vis-à-vis du bandeau</td>
                <td className="p-2">12 mois (localStorage)</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div>
          <h2 className="font-heading text-lg font-bold text-slate-900">Modifier vos préférences</h2>
          <p className="mt-2">
            Vous pouvez à tout moment réinitialiser votre choix concernant le bandeau de cookies.
          </p>
          <button onClick={clear} data-testid="cookies-reset"
                  className="mt-3 text-xs font-semibold px-4 py-2 rounded-lg border border-slate-200 hover:bg-slate-50">
            Réinitialiser mes préférences cookies
          </button>
        </div>
      </div>
    </div>
  );
}
